import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import DashboardLayout from './layouts/DashboardLayout';
import Dashboard from './pages/Dashboard';
import ReservationDetail from './components/Reservation/ReservationDetail';
import theme from './theme/theme';
import './App.css';
import EmailTemplateList from './pages/EmailTemplates/EmailTemplateList';
import EmailTemplateEditor from './pages/EmailTemplates/EmailTemplateEditor';
import AgentList from './pages/Agents/AgentList';
import AgentReservations from './pages/Agents/AgentReservations';
import FeedbackAnalytics from './pages/Feedback/FeedbackAnalytics';
import FeedbackList from './pages/Feedback/FeedbackList';
import FeedbackDetail from './pages/Feedback/FeedbackDetail';
import WhatsAppTemplateList from './pages/WhatsAppTemplates/WhatsAppTemplateList';
import WhatsAppTemplateEditor from './pages/WhatsAppTemplates/WhatsAppTemplateEditor';
import PropertyRecommendation from './components/PropertyRecommendation/PropertyRecommendation';
import GroupsList from './pages/Groups/GroupsList';
import CreateGroup from './pages/Groups/CreateGroup';
import CampaignsList from './pages/Campaigns/CampaignsList';
import CreateCampaign from './pages/Campaigns/CreateCampaign';
import CreateWhatsappCampaign from './pages/Campaigns/CreateWhatsappCampaign';
import CampaignDetails from './pages/Campaigns/CampaignDetails';
import UserList from './pages/Users/UserList';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DashboardLayout>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/reservations/:id" element={<ReservationDetail />} />
          <Route path="/analytics" element={<ComingSoon title="Analytics" />} />
          <Route path="/settings" element={<ComingSoon title="Settings" />} />
          
          {/* Email Templates */}
          <Route path="/email-templates" element={<EmailTemplateList />} />
          <Route path="/email-templates/new" element={<EmailTemplateEditor />} />
          <Route path="/email-templates/edit/:id" element={<EmailTemplateEditor />} />
          <Route path="/email-templates/view/:id" element={<EmailTemplateEditor />} />
          
          {/* WhatsApp Templates */}
          <Route path="/whatsapp-templates" element={<WhatsAppTemplateList />} />
          <Route path="/whatsapp-templates/new" element={<WhatsAppTemplateEditor />} />
          <Route path="/whatsapp-templates/edit/:id" element={<WhatsAppTemplateEditor />} />
          <Route path="/whatsapp-templates/view/:id" element={<WhatsAppTemplateEditor />} />
          
          {/* Agents */}
          <Route path="/agents" element={<AgentList />} />
          <Route path="/agents/new" element={<ComingSoon title="Create Agent" />} />
          <Route path="/agents/edit/:id" element={<ComingSoon title="Edit Agent" />} />
          <Route path="/agents/:id/reservations" element={<AgentReservations />} />
          
          {/* Feedback */}
          <Route path="/feedback/analytics" element={<FeedbackAnalytics />} />
          <Route path="/feedback-details/:id" element={<FeedbackDetail />} />
          <Route path="/feedback" element={<FeedbackList />} />
          
          {/* Groups */}
          <Route path="/groups" element={<GroupsList />} />
          <Route path="/groups/create" element={<CreateGroup />} />
          <Route path="/groups/:id" element={<ComingSoon title="Group Details" />} />
          <Route path="/groups/:id/edit" element={<ComingSoon title="Edit Group" />} />
          <Route path="/groups/:id/analytics" element={<ComingSoon title="Group Analytics" />} />
          
          {/* Campaigns */}
          <Route path="/campaigns" element={<CampaignsList />} />
          <Route path="/campaigns/create" element={<CreateCampaign />} />
          <Route path="/campaigns/create-whatsapp" element={<CreateWhatsappCampaign />} />
          <Route path="/campaigns/:id" element={<CampaignDetails />} />
          <Route path="/campaigns/:id/edit" element={<ComingSoon title="Edit Campaign" />} />
          <Route path="/campaigns/:id/send" element={<CampaignDetails />} />
          
          {/* User Management */}
          <Route path="/users" element={<UserList />} />
          
          {/* Other routes */}
          <Route path="/property-recommendations" element={<PropertyRecommendation />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </DashboardLayout>
    </ThemeProvider>
  );
};

// Simple component for routes that are not yet implemented
const ComingSoon: React.FC<{ title: string }> = ({ title }) => (
  <div style={{ textAlign: 'center', padding: '80px 0' }}>
    <h2 style={{ fontSize: '24px', marginBottom: '10px' }}>{title}</h2>
    <p style={{ color: '#666' }}>This feature is coming soon!</p>
  </div>
);

export default App;
